import apis  from "../../api/index";
import {utils} from "../../utils/utils";

export default {
    name: "MenuManage",
    components: {
    },
    data() {
      return {
        query: {
          menuName:'',
          pageIndex: 1,
          pageSize: 100
        },
        pageTotal:0,
        size: "small",
        tableData: [],
        dialogVisibleAdd: false,
        dialogVisibleEdit: false,
        menuTypeList: ["目录", "菜单", "按钮"],
        dataForm: {
          MenuID: 0,
          Type: 1,
          MenuName: "",
          ParentMenuID: 0,
          ParentMenuName: "",
          ViewPath: "",
          Perms: '',
          OrderNum: 0,
          Icon: ""
        },
        dataRule: {
          MenuName: [{ required: true, message: "菜单名称不能为空", trigger: "blur" }],
          ParentMenuName: [{ required: true, message: "上级菜单名称不能为空", trigger: "change" }],
          ViewPath: [{ required: true, message: "菜单路由不能为空", trigger: "blur" }],
          Icon:[{ required: true, message: "菜单图标不能为空", trigger: "blur" }]
        },
        popupTreeData: [],
        popupTreeProps: {
          id:'MenuID',
          label: "MenuName",
          children: "Children"
        },
        scrollHeight:250
      }
    },
    created() {
    },
    methods: {
      // 查询表格数据
      queryTableData() {
        let that = this
        let queryPara = utils.deepCopy(that.query);
        apis.getAllMenus(queryPara).then(res => {
            that.tableData = res.resultData;
            that.pageTotal = res.totalCount || 0;
        });
      },
      // 查询目录树数据
      queryTreeData(callBack){
        let queryType = 0
        if(this.dataForm.Type+''==='0'||this.dataForm.Type+''==='1'){
          queryType = '0'
        }else{
          queryType = '0,1'
        }
        let para ={
          type:queryType,
          pageIndex: 1,
          pageSize: 10000
        }
        apis.getAllMenus(para).then(res => {
            this.popupTreeData = this.getParentMenuTree(res.resultData)
            if(callBack){
              callBack()
            }
        });
      },
      // 获取上级菜单树
      getParentMenuTree: function(tableData) {
        let parent = {
          MenuID:0,
          ParentMenuID: 0,
          MenuName: "顶级菜单",
          Children: tableData
        };
        return [parent]
      },
      // 清空条件
      onClearCondtionChange(){
        this.query.menuName = ""
      },
      // 菜单类型切换
      onChangeType(){
        if(this.dataForm.Type === 0 || this.dataForm.Type === 1) {
          this.dataForm.Perms = '/'
        }else{
          this.dataForm.Perms = ''
        }
        this.queryTreeData()
      },
      // 显示新增界面
      onChangeAdd() {
        this.dialogVisibleAdd = true;
        this.dataForm = {
          MenuID: 0,
          Type: 1,
          MenuName: "",
          ParentMenuID: 0,
          ParentMenuName: "",
          ViewPath: "",
          Perms: '',
          OrderNum: 0,
          Icon: ""
        };
        this.queryTreeData()
      },
      // 显示编辑界面
      onChangeEdit(row) {
        let that = this
        that.dialogVisibleEdit = true;
        that.queryTreeData(function(){
          that.$nextTick(() => {
            let paraNode = that.$refs.popupTree.getNode(row.ParentMenuID)
            if(paraNode){
              that.dataForm.ParentMenuName = paraNode.data.MenuName
            }
            Object.assign(that.dataForm, row);
          });
        })
      },
      // 删除
      onChangeDelete(row) {
        this.$confirm("您确认删除该内容吗？", "提示", {
          type: "warning"
        }).then(() => {
          if(row){
            let params = {
              menuId:row.MenuID
            };
            apis.deleteMenu(params).then(res => {
              // -1失败
              // -2不存在
              // -3有子菜单
              if (res===-2) {
                this.$message({
                  message: "删除的内容不存在",
                  type: "error"
                });
              } else if(res===-3) {
                this.$message({
                  message: "有子内容无法删除，请先删除子内容",
                  type: "error"
                });
              } else if(res===-1) {
                this.$message({
                  message: "删除失败，请重试",
                  type: "error"
                });
              }else{
                this.queryTableData();
                this.$message({ message: "删除成功", type: "success" });
              }
            })
          }
        });
      },
      // 菜单树选中
      onTreeSelectChange(data) {
        this.dataForm.ParentMenuID = data.MenuID
        this.dataForm.ParentMenuName = data.MenuName
      },
      // 添加菜单
      addMenuFunction() {
        this.$refs["dataForm"].validate(valid => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              let params = Object.assign({}, this.dataForm);
              if(this.dataForm.Type === 0 || this.dataForm.Type === 1) {
                params.Perms = '/'
              }
              delete params.ParentMenuName
              apis.addMenu(params).then(res => {
                if (res>0) {
                  this.$message.success("操作成功");
                  this.$refs["dataForm"].resetFields();
                  this.dialogVisibleAdd = false;
                } else if(res===-2) {
                  this.$message({
                    message: "该名称已经存在",
                    type: "error"
                  });
                }else{
                  this.$message({
                    message: "添加失败",
                    type: "error"
                  });
                }
                this.queryTableData();
              })
            })
          }
        })
      },
      // 编辑菜单
      editMenuFunction(){
        this.$refs["dataForm"].validate(valid => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              let params = Object.assign({}, this.dataForm);
              if(this.dataForm.Type === 0 || this.dataForm.Type === 1) {
                params.Perms = '/'
              }
              delete params.ParentMenuName
              delete params.PermBtns
              delete params.Children
              delete params.Level
              apis.updateMenu(params).then(res => {
                // -1失败
                // -2不存在
                if (res === -2) {
                  this.$message({
                    message: "修改的内容不存在",
                    type: "error"
                  });
                }else if(res === -1) {
                  this.$message({
                    message: "修改失败，请重试",
                    type: "error"
                  });
                }else{
                  this.$refs["dataForm"].resetFields();
                  this.dialogVisibleEdit = false;
                  this.queryTableData();
                  this.$message({ message: "修改成功", type: "success" });
                }
              })
            })
          }
        })
      },
      // 动态计算表格高度
      calcTableHeight(){
        this.$nextTick(() => {
          let height = $(".content-box .content").height() - $(".content-box .content .seach-container").height() - 16 - 24 -72
          this.scrollHeight = (height)
        });
      },
      // 页面切换事件
      handlePageChange(val) {
          this.query.pageIndex = val
          this.queryTableData()
      },
      // 页码切换事件
      handleSizeChange(val){
          this.query.pageIndex = 1
          this.query.pageSize = val
          this.queryTableData()
      },
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight()
      }
      this.queryTableData()
    },
    watch: {

    },
    activated: function () {
    },

    deactivated: function () {

    },
  };
